import * as types from '@store/types'

export const ordinators = [
  {
    name: 'Maiores descontos',
    icon: 'bookmark-favorite-label1',
    action: 'discount'
  },
  {
    name: 'Mais curtidas',
    icon: 'heart',
    action: 'likes'
  },
  // {
  //   name: 'Mais próximo',
  //   icon: 'map-marker',
  //   action: 'nearby'
  // },
  {
    name: 'A-Z',
    icon: 'arrow-down',
    action: 'alphabetical'
  },
  {
    name: 'Z-A',
    icon: 'arrow-up1',
    action: 'alphainverse'
  }
]

export const filters = [
  {
    name: 'Exclusivo',
    icon: 'star-favorite',
    action: 'exclusive'
  },
  {
    name: 'Dinheiro de volta',
    icon: 'dollar-payments-conversion',
    action: 'cashback',
    permission: 'cashback_tab'
  }
]

const state = {
  filters: {
    cashback: false,
    exclusive: false
  },
  ordinator: ''
}

const getters = {
  [types.FILTERS]: ({ filters }) => filters,
  [types.FILTER_ORDINATOR]: ({ ordinator }) => ordinator
}

const mutations = {
  [types.FILTERS]: (state, payload) => {
    state.filters = payload
  },
  [types.FILTER_ORDINATOR]: (state, payload) => {
    state.ordinator = payload
  }
}

const actions = {
  [types.FILTERS]: ({ commit }, payload) => commit(types.FILTERS, payload),
  [types.FILTER_ORDINATOR]: ({ commit }, payload) => commit(types.FILTER_ORDINATOR, payload)
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/filter.js